// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".message-background[data-v-3c9c0860]{background:#f1f7fd;padding:20px}.title-resume[data-v-3c9c0860]{line-height:normal!important;font-size:18px!important;width:89%}", ""]);
// Exports
module.exports = exports;
